module.exports = "<!-- ko with: list -->\n<ul class=\"tags-list\" data-bind=\"foreach: visibleItems\">\n\t<li class=\"tag\" data-bind=\"css: {active: selected, disabled: disabled}, css2: $parent.name + '-' + name,\n\t\t\t\t\t\t\t\t\t\t   click: $parent.handleClick, attr: {title: hint}\">\n\t\t<span data-bind=\"text: title\"></span>\n\t</li>\n</ul>\n<!-- /ko -->"


//////////////////
// WEBPACK FOOTER
// ./modules/shop/catalog/templates/filters/attribute-filter.html
// module id = szBx
// module chunks = 8 9